import { connect } from 'react-redux';

import {
  getCurrentRepositoryOwnerName,
  getCurrentRepositorySlug,
} from 'src/selectors/repository-selectors';
import { getTargetUserKey } from 'src/selectors/user-selectors';
import { BucketState } from 'src/types/state';

import ConnectBranchActions from '../components/branch-list-actions';

const mapStateToProps = (state: BucketState) => {
  const principalId = getTargetUserKey(state);
  const repositoryOwner = getCurrentRepositoryOwnerName(state) || '';
  const repositorySlug = getCurrentRepositorySlug(state) || '';

  return {
    repositoryOwner,
    repositorySlug,
    principalId,
  };
};

export default connect(mapStateToProps)(ConnectBranchActions);
